import { object, number, string, boolean } from "yup";
import { MoneyResource, moneySchema } from "./MoneyResource";

export interface ClinicSubscriptionResource {
  subscription: {
    id: number;
    name: string;
  };
  startedAt: string;
  finishedAt: string;
  programPdfType: "BASIC" | "ENTERPRISE";
  price: MoneyResource | null;
  promoPrice: MoneyResource | null;
  priceForNextPatient: MoneyResource | null;
  priceForNextDietitian: MoneyResource | null;
  activePatientsInSubscriptionPlan: number | null;
  activeDietitiansInSubscriptionPlan: number | null;
  maxActivePatientsInSubscriptionPlan: number | null;
  maxActiveDietitiansInSubscriptionPlan: number | null;
  advancedChat: boolean;
  photoDiaryAi: {
    active: boolean;
    limitPerUser: number;
  };
}

export const clinicSubscriptionSchema = object().shape({
  subscription: object()
    .shape({
      id: number().required(),
      name: string().required(),
    })
    .required(),
  startedAt: string().required(),
  finishedAt: string().required(),
  programPdfType: string().oneOf(["BASIC", "ENTERPRISE"]).required(),
  price: moneySchema.nullable().default(null),
  promoPrice: moneySchema.nullable().default(null),
  priceForNextPatient: moneySchema.nullable().default(null),
  priceForNextDietitian: moneySchema.nullable().default(null),
  activePatientsInSubscriptionPlan: number().nullable().default(null),
  activeDietitiansInSubscriptionPlan: number().nullable().default(null),
  maxActivePatientsInSubscriptionPlan: number().nullable().default(null),
  maxActiveDietitiansInSubscriptionPlan: number().nullable().default(null),
  advancedChat: boolean().required(),
  photoDiaryAi: object({
    active: boolean().required(),
    limitPerUser: number().required(),
  }).required(),
});
